<p-dialog
  modal="true"
  styleClass="atlas-dialog-m"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h4>{{ 'web-content.edit.header' | translate | titlecase }}</h4>
  </ng-template>
  <div class="mb-27 mct-flex-lt-md mct-col-lt-md mct-flex-gt-md mct-row-gt-md mct-gap-20"   >
    <div class="mct-flex mct-col mct-basis-34"  >
      <label class="light-text">{{ 'web-content.edit.title-label' | translate | titlecase }}</label>
      <input
        type="text"
        class="title-field"
        placeholder="{{ 'web-content.search-params.title' | translate | titlecase }}"
        [(ngModel)]="webContentRecord.ContentTitle"
        data-cy="inputWebContentTitle"
        [disabled]="isReadOnly"
      />
    </div>
    <div class="mct-flex mct-col mct-basis-33"  >
      <label class="light-text">{{ 'web-content.edit.format' | translate | titlecase }}</label>
      <p-select
        placeholder="{{ 'web-content.search-params.select-label' | translate }}"
        appendTo="body"
        [(ngModel)]="webContentRecord.ContentFormat"
        [options]="webContentFormats"
        [style]="{ width: '100%', height: '36px' }"
        data-cy="selectWebContentFormat"
        [disabled]="isReadOnly"
      ></p-select>
    </div>
    <div class="mct-flex mct-col mct-basis-33"  >
      <label class="light-text">{{ 'web-content.edit.content-type' | translate | titlecase }}</label>
      <p-select
        placeholder="{{ 'web-content.search-params.select-label' | translate }}"
        appendTo="body"
        [(ngModel)]="webContentRecord.ContentTypeID"
        [options]="webContentTypes"
        [style]="{ width: '100%', height: '36px' }"
        data-cy="selectWebContentType"
        [disabled]="isReadOnly"
        optionLabel="ContentType"
        optionValue="ContentTypeID"
      ></p-select>
    </div>
    <div class="mct-flex mct-col mct-basis-33"  >
      <label class="light-text">{{ 'web-content.edit.referral-type' | translate | titlecase }}</label>
      <p-select
        placeholder="{{ 'web-content.search-params.select-label' | translate }}"
        appendTo="body"
        [(ngModel)]="webContentRecord.ReferralType"
        [options]="referralTypes"
        [style]="{ width: '100%', height: '36px' }"
        data-cy="selectReferralType"
        [disabled]="isReadOnly"
      ></p-select>
    </div>
  </div>
  <ng-container *ngIf="webContentRecord.ContentFormat">
    <div class="mb-27">
      <div
        *ngIf="
          webContentRecord.ContentFormat === webContentFormatEnum.Document ||
          webContentRecord.ContentFormat === webContentFormatEnum.Image ||
          webContentRecord.ContentFormat === webContentFormatEnum.Report
        "
      >
        <input #uploader type="file" [disabled]="isReadOnly" hidden (change)="fileSelected($event)" data-cy="inputWebContentUploadFile" />
        <button pButton type="button" class="atlas-btn atlas-btn-primary mr-10" [disabled]="isReadOnly" (click)="uploader.click()">
          <span *ngIf="!webContentRecord.ContentID">{{ 'web-content.edit.upload-a-file' | translate | uppercase }}</span>
          <span *ngIf="webContentRecord.ContentID">{{ 'web-content.edit.change-file' | translate | uppercase }}</span>
        </button>
        <span class="f-si" *ngIf="fileToUpload">{{ fileToUpload.name }}</span>
      </div>
      <div *ngIf="webContentRecord.ContentFormat === webContentFormatEnum.Html">
        <form #test="ngForm">
          <div>
            <wl-modular-wysiwyg-editor
              name="html"
              #webContentRecordHTML="ngModel"
              [(ngModel)]="webContentRecord.HTML"
              [disabled]="isReadOnly"
              [required]="!isReadOnly"
              [compact]="true"
            ></wl-modular-wysiwyg-editor>
          </div>
        </form>
      </div>
      <div *ngIf="webContentRecord.ContentFormat === webContentFormatEnum.Export">
        <label class="light-text"
          >{{ 'web-content.edit.export-sql' | translate }}
          <textarea cols="120" [disabled]="isReadOnly" pInputTextarea [(ngModel)]="webContentRecord.SQL"></textarea>
        </label>
      </div>
    </div>
  </ng-container>
  <a *ngIf="!showAccessTextArea; else accessTextArea" (click)="showAccessTextArea = true">
    {{ 'web-content.edit.control-access-text' | translate | ucfirst }}
  </a>
  <ng-template #accessTextArea>
    <div class="mb-27">
      <p-checkbox
        binary="true"
        [(ngModel)]="webContentRecord.RestrictForMembersOnly"
        [disabled]="isReadOnly"
        inputId="restrictForMembersOnly"
      >
      </p-checkbox>
      <label for="restrictForMembersOnly">
        {{ 'web-content.edit.only-members-checkbox' | translate | ucfirst }}
      </label>
    </div>
    <label class="light-text">{{ 'web-content.edit.restrictions-based-on-aff-codes' | translate | ucfirst }}</label>
    <div class="atlas-autocomplete">
    <p-autocomplete
      #autoComplete
      appendTo="body"
      [(ngModel)]="selectedAffCodes"
      [disabled]="isReadOnly"
      [multiple]="true"
      [suggestions]="affCodeSearchResults"
      (completeMethod)="searchAffCodes($event)"
      (ngModelChange)="syncAffCodes()"
    >
    </p-autocomplete>
    </div>
    <span class="mt-6 light-text">{{ 'web-content.edit.aff-code-help-text' | translate | ucfirst }}</span>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-wrap mct-justify-between mct-items-center" style="width: 100%;"  >
      <div *ngIf="webContentRecord.ContentUrl" class="div-copy-link">
        <wl-ephemeral-content-swap #contentSwap class="mr-20">
          <a ngxClipboard [cbContent]="webContentRecord.ContentUrl" (click)="contentSwap.show()">
            {{ 'web-content.search-grid.copy-url' | translate }}
          </a>
          <div class="wl-ephemeral-content">
            {{ 'web-content.search-grid.copied-to-clipboard' | translate | ucfirst }}
          </div>
        </wl-ephemeral-content-swap>

        <i class="light-grey" *ngIf="webContentRecord.ContentFormat === webContentFormatEnum.Image" class="mr-20">|</i>
        <wl-ephemeral-content-swap #contentSwapMemberPortalUrl *ngIf="webContentRecord.ContentFormat === webContentFormatEnum.Image">
          <a ngxClipboard [cbContent]="webContentMemberPortalUrl + webContentRecord.ContentID" (click)="contentSwapMemberPortalUrl.show()">
            {{ 'web-content.search-grid.copy-url-new' | translate }}
          </a>
          <div class="wl-ephemeral-content">
            {{ 'web-content.search-grid.copied-to-clipboard' | translate | ucfirst }}
          </div>
        </wl-ephemeral-content-swap>
      </div>
      <div>
        <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-12" [disabled]="isSaving" (click)="show = false">
          {{ 'common.cancel' | translate | uppercase }}
        </button>
        <button
          type="button"
          class="atlas-btn atlas-btn-primary"
          [disabled]="
            isReadOnly ||
            isSaving ||
            !this.webContentRecord.ContentTitle ||
            !this.webContentRecord.ContentFormat ||
            !this.webContentRecord.ContentTypeID
          "
          (click)="save()"
          data-cy="btnWebContentSave"
        >
          <wl-busy [show]="isSaving"></wl-busy>
          <span *ngIf="!isSaving">{{ 'common.save' | translate | uppercase }}</span>
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
